import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

// Landing target for Stripe hosted onboarding return/refresh. Re-syncs KYC status, then returns
// the agency to their dashboard.
export default function AgencyConnectReturn() {
  const nav = useNavigate();
  useEffect(() => {
    (async () => {
      try { await api.get("/agency/connect/status"); } catch { /* noop */ }
      nav("/agency", { replace: true });
    })();
  }, [nav]);
  return (
    <div className="mx-auto max-w-md py-20 text-center text-sm text-slate-600" data-testid="agency-connect-return">
      Finishing Stripe setup…
    </div>
  );
}
